function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const CollectionEditBuilder = require('../pipelines/collection-edit-builder');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const Collection = require('../entities/collection');

const PagedList = require('../entities/paged-list');

const AccessContext = require('./contexts/access-context');

const CollectionsRepoHelper = require('./collections-repo-helper');

const CollectionUpdatePipeline = require('../pipelines/collection-update-pipeline');

const TagsRepo = require('./tags-repo');

const CollectionLocalizationDictionary = require('../entities/collection-localization-dictionary');

const rewindPolygon = require('../utils/rewind');

const {
  geoShape
} = require('../utils/serialize');

const {
  geoPoint
} = require('../utils/serialize');

const {
  compileFromLists
} = require('../utils/filterQueries/polygonQueries');

const {
  strList,
  strinct,
  polygon
} = require('../utils/serialize');
/*:: type Coordinate = [number, number];*/


const TYPE_NAME = TagsRepo.TYPE_NAMES.collection;
const fields = ['id', 'slug', 'name', 'shortName', 'desc', 'priority', 'scores', 'enabled', 'images', 'meta', 'polygons', 'businessFilter', 'businessOfferFilter', 'scheduleIds'];
const listFields = ['id', 'name', 'shortName', 'priority', 'scores', 'enabled', 'images', 'scheduleIds'];
const searchFields = ['id', 'slug', 'name', 'scores', 'enabled', 'iconSmallImages.url'];

class CollectionRepo {
  constructor(client
  /*: ApiClient*/
  , id
  /*: collectionId*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.collectionId = id;
    this.context = context;
  }

  getTags()
  /*: (Promise<any>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const collectionId = this.collectionId;
    return this.client.tags.list(propertyId, TYPE_NAME, collectionId);
  }

  updateTags(newTags
  /*: Array<string>*/
  )
  /*: (Promise<any>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const collectionId = this.collectionId;
    return this.client.tags.reconcile(propertyId, TYPE_NAME, collectionId, newTags);
  }

  addTag(tagName
  /*: string*/
  )
  /*: (Promise<any>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const collectionId = this.collectionId;
    return this.client.tags.create(propertyId, TYPE_NAME, collectionId, tagName).then(() => true).catch(() => false);
  }

  removeTag(tagName
  /*: string*/
  )
  /*: (Promise<any>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const collectionId = this.collectionId;
    return this.client.tags.delete(propertyId, TYPE_NAME, collectionId, tagName).then(() => true).catch(() => false);
  }

  getLocalizations()
  /*: Promise<PagedList<any>>*/
  {
    const ALL_LOCALE_FIELDS = ['id', 'type', 'modelId', 'locale', 'content', 'priority', 'propertyId'];
    const {
      propertyId
    } = this.context.serialize();
    const collectionId = this.collectionId;
    const path = `/properties/${propertyId}/collections/${collectionId}/localizations`;
    const req = new this.client.Request(path, {}, ALL_LOCALE_FIELDS);
    req.parse = CollectionLocalizationDictionary.fromJson;
    return this.client.get(req);
  }

  setLocalization({
    locale,
    content
  })
  /*: Promise<any>*/
  {
    const setFields = ['id'];
    const {
      propertyId
    } = this.context.serialize();
    const collectionId = this.collectionId;
    const path = `/properties/${propertyId}/collections/${collectionId}/localizations`;
    const params = {
      locale,
      content
    };
    const req = new this.client.Request(path, params, setFields);
    req.serialize = CollectionLocalizationDictionary.serialize;
    return this.client.post(req);
  }

  getValidations()
  /*: Promise<any>*/
  {
    const getFields = [];
    const {
      propertyId
    } = this.context.serialize();
    const collectionId = this.collectionId;
    const path = `/properties/${propertyId}/collections/${collectionId}/validation`;
    const req = new this.client.Request(path, {}, getFields);
    return this.client.get(req);
  }

  businessFeed({
    /*: {
        timezone: string, //
        offersContextGeoArea: Array<Coordinate>,
        locationsContextGeoArea: Array<Coordinate>,
        orderingGeoPoint: Coordinate,
        locationsOriginGeoPoint: Coordinate,
        locationsOrderingGeoPoint: Coordinate,
        offersLocationsOrderingGeoPoint: Coordinate,
        limit: number,
        cursor: string,
        fields: Array<string>,
        locale: ?Array<string>
      }*/

    timezone,
    // Used to resolve Offer schedules
    offersContextGeoArea,
    // Used to crop Offers
    locationsContextGeoArea,
    // Used to crop Business Locations
    orderingGeoPoint,
    // Used to sort Businesses by their closest Offer
    locationsOriginGeoPoint,
    // Used to calculate distance to Locations
    locationsOrderingGeoPoint,
    // Used to sort Business Locations
    offersLocationsOrderingGeoPoint,
    // Used to sort Offer Locations
    limit,
    // Max results to return
    cursor,
    fields: customFields,
    locale
  } = {}) {
    const collectionId = this.collectionId;
    const {
      propertyId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/collections/${collectionId}/businesses`;
    const businessFeedFields = ['slug', 'name', `offers(${['shareUri', 'headline', 'subhead', 'heroImages.url', 'locations(id,address(streetAddress,street,city))'].join(',')})`];
    const params = {
      timezone,
      offersContextGeoArea: strList(geoShape(offersContextGeoArea)),
      locationsContextGeoArea: strList(geoShape(locationsContextGeoArea)),
      orderingGeoPoint: strList(geoPoint(orderingGeoPoint)),
      locationsOriginGeoPoint: strList(geoPoint(locationsOriginGeoPoint)),
      locationsOrderingGeoPoint: strList(geoPoint(locationsOrderingGeoPoint)),
      offersLocationsOrderingGeoPoint: strList(geoPoint(offersLocationsOrderingGeoPoint)),
      limit,
      cursor,
      locale: strList(locale)
    };
    const req = new this.client.Request(path, params, customFields || businessFeedFields);
    req.useCursor = true;
    return this.client.get(req);
  }

  edit()
  /*: Promise<CollectionUpdatePipeline>*/
  {
    const _this = this;

    return _call(function () {
      return _await(new CollectionEditBuilder(_this.client, _this.context, _this.collectionId).build());
    });
  }

}

class CollectionsRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context;

    this.for = (id
    /*: collectionId*/
    ) => new CollectionRepo(client, id, context);

    this.icanhas = this.for;
  }

  list({
    /*: { enabled: boolean }*/

    enabled
  } = {})
  /*: Promise<PagedList<Collection>>*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const req = new this.client.Request(`/properties/${propertyId}/collections`, {
      enabled
    }, listFields);
    req.useCursor = true;
    req.parse = Collection.fromJson;
    return this.client.get(req);
  }

  search({
    /*: {
        query: string,
        tags: Array<string>,
        fields: Array<string>,
        locale: ?Array<string>
      }*/

    query,
    tags,
    fields: customFields,
    locale
  } = {})
  /*: Promise<PagedList<Collection>>*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/collections/search`;
    const params = {
      q: strinct(query),
      tagNames: strList(tags),
      locale: strList(locale)
    };
    const req = new this.client.Request(path, params, customFields || searchFields);
    req.parse = Collection.fromJson;
    return this.client.get(req);
  } // DANGER!
  // If we ever change this to use the search index, the search endpoint will have to accept the field scheduleIds


  coreDetails(collectionId
  /*: string*/
  )
  /*: Promise<Collection>*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const req = new this.client.Request(`/properties/${propertyId}/collections/${collectionId}`, {}, fields);
    req.parse = Collection.fromJson;
    return this.client.get(req);
  }

  details(collectionId
  /*: string*/
  )
  /*: Promise<Collection>*/
  {
    const repoHelper = new CollectionsRepoHelper(this.client, this.context);
    return this.coreDetails(collectionId).then(collection => repoHelper.updateFilterCategoriesForEdit(collection));
  }

  coreCreate(collection
  /*: Collection | Object*/
  )
  /*: Promise<Collection>*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const req = new this.client.Request(`/properties/${propertyId}/collections`, collection, fields);
    req.parse = Collection.fromJson;
    req.serialize = Collection.serialize;
    return this.client.post(req);
  }

  updateSlug(collection
  /*: Collection*/
  , updates
  /*: Collection*/
  )
  /*: Promise<string>*/
  {
    const _this2 = this;

    return _call(function () {
      if (collection.id == null) throw new Error(`Cannot update collection "${collection.name}" without id`);
      const slugUnchanged = collection.slug && collection.slug === updates.slug;
      const noSlugUpdates = !(updates.slug || updates.name);
      if (slugUnchanged || noSlugUpdates) return Promise.resolve(collection.slug);

      const {
        propertyId
      } = _this2.context.serialize();

      const path = `/properties/${propertyId}/collections/${collection.id}/slugs`;
      const req = new _this2.client.Request(path, {
        inputString: updates.slug || updates.name
      }, ['slug']);
      return _await(_this2.client.post(req));
    });
  }

  coreUpdate(collection
  /*: Collection*/
  , updatedCollection
  /*: Collection*/
  )
  /*: Promise<Collection>*/
  {
    const {
      propertyId
    } = this.context.serialize();
    if (!collection.id) throw new Error('Missing required Collection property: id');
    const collectionId = collection.id;
    const path = `/properties/${propertyId}/collections/${collectionId}`;
    const req = new this.client.Request(path, updatedCollection, fields);
    req.parse = Collection.fromJson;
    req.serialize = Collection.serialize;
    return this.client.patch(req);
  }

  delete(collectionId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const req = new this.client.Request(`/properties/${propertyId}/collections/${collectionId}`, {}, []);
    return this.client.delete(req);
  }

  enable(collectionId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/collections/${collectionId}`;
    const req = new this.client.Request(path, {
      enabled: true
    }, fields);
    return this.client.patch(req);
  }

  disable(collectionId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      propertyId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/collections/${collectionId}`;
    const req = new this.client.Request(path, {
      enabled: false
    }, fields);
    return this.client.patch(req);
  } // TODO: Remove this when everything is using initialize()


  create(newCollection
  /*: Collection*/
  )
  /*: Promise<Collection>*/
  {
    const updates = {
      collection: newCollection,
      filterCategories: newCollection.filterCategories
    };
    return this.initialize().then(collectionCreate => collectionCreate.update(updates)).then(collectionCreate => collectionCreate.getInstance('collection'));
  } // TODO: Deprecate this and use CollectionRepo.edit()


  edit(collectionId
  /*: string*/
  )
  /*: Promise<CollectionUpdatePipeline>*/
  {
    const _this3 = this;

    return _call(function () {
      return _await(_this3.for(collectionId).edit());
    });
  }

  initialize()
  /*: Promise<CollectionUpdatePipeline>*/
  {
    const _this4 = this;

    return _call(function () {
      return _await(new CollectionEditBuilder(_this4.client, _this4.context).build());
    });
  }

  mergePolygons({
    /*: {
        include: Array<Polygon>, exclude: Array<Polygon>, mergeHoles: boolean
      }*/

    include,
    exclude = [],
    mergeHoles
  })
  /*: Promise<{ polygons: Array<Polygon>, warnings: Array<string> }>*/
  {
    const _this5 = this;

    return _call(function () {
      const path = `/collections/polygons/merge`;
      const params = {
        logic: compileFromLists({
          include: include.map(p => rewindPolygon(polygon(p))),
          exclude: exclude.map(p => rewindPolygon(polygon(p)))
        }),
        mergeHoles
      };
      const polygonFields = ['polygons', 'warnings.name', 'warnings.message', 'warnings.details.actual', 'warnings.details.allowed', 'warnings.details.index'];
      const req = new _this5.client.Request(path, params, polygonFields);
      return _await(_this5.client.post(req));
    });
  }

}

module.exports = CollectionsRepo;